/**
 * License Inventory Mock Data
 * Contains dummy data for license inventory list
 * This data will be replaced with real API responses when backend is ready
 */

import type { License } from '../components/Dashboard/LicenseInventory/type';

const LICENSE_INVENTORY_MOCK_DATA: License[] = [
  {
    id: '1',
    vendor: 'SAP',
    category: 'ERP',
    logo: 'SAP',
    status: 'Active',
    utilization: 11650,
    utilizationMax: 15500,
    utilizationPercent: 68,
    annualCost: 4850000,
    costTrend: 21,
    renewalDate: 'Feb 05, 2026',
    risk: 'Low',
  },
  {
    id: '2',
    vendor: 'Office 365',
    category: 'Productivity',
    logo: 'Office 365',
    status: 'Active',
    utilization: 17100,
    utilizationMax: 22800,
    utilizationPercent: 74,
    annualCost: 4850000,
    costTrend: 21,
    renewalDate: 'Feb 05, 2026',
    risk: 'Low',
  },
  {
    id: '3',
    vendor: 'AWS',
    category: 'Develop',
    logo: 'AWS',
    status: 'Active',
    utilization: 11650,
    utilizationMax: 15500,
    utilizationPercent: 68,
    annualCost: 4850000,
    costTrend: 21,
    renewalDate: 'Feb 05, 2026',
    risk: 'Low',
  },
];

export default LICENSE_INVENTORY_MOCK_DATA;
